import { HttpContextToken } from '@angular/common/http';

/**
 * Prevents the session refresh interceptor from handling an HTTP request that is
 * already part of the session refresh workflow.
 */
export const BYPASS_SESSION_REFRESH_INTERCEPTOR = new HttpContextToken<boolean>(
    () => false
);

/**
 * Prevents a request that has already been retried after a session refresh
 * from starting another refresh cycle.
 */
export const SESSION_REFRESH_RETRY_ATTEMPTED = new HttpContextToken<boolean>(
    () => false
);
